import { render } from "./SpaTreatmentAddOns.vue?vue&type=template&id=304ae0d3&scoped=true"
import script from "./SpaTreatmentAddOns.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentAddOns.vue?vue&type=script&lang=js"

import "./SpaTreatmentAddOns.vue?vue&type=style&index=0&id=304ae0d3&lang=css"
import "./SpaTreatmentAddOns.vue?vue&type=style&index=1&id=304ae0d3&scoped=true&lang=css"
import "./SpaTreatmentAddOns.vue?vue&type=style&index=2&id=304ae0d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304ae0d3"]])

export default __exports__